import React from 'react';
import Box from '@mui/material/Box';
import { Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import {
    INTERNAL_CHECKBOX_FILTER_LABELS, INTERNAL_RANGE_FILTER_LABELS, ONE_TO_SIX_OPTIONS_MAX, ONE_TO_SIX_OPTIONS_MIN,
} from '../../constants/filterOptions';
import CheckboxFilter from 'components/commons/CheckboxFilter';
import RangeAutocomplete from 'components/FilterFields/RangeAutocomplete';
import TextFieldFilter from 'components/TextFieldFilter';
import {
    validateCharacters,
    validateDecimalPlaces,
    validateMaxLength
} from 'lib/Validations';

function InternalFilter(props) {
    const validateInput = (input) => {
        return (
            validateCharacters(input) ||
            validateMaxLength(input) ||
            validateDecimalPlaces(input)
        );
    };
    return (
        <Box
            sx={{
                mb: 2,
                width: '100%',
            }}
        >
            <Typography sx={{ mb: 2.5, display: 'block' }} variant="text4" gutterBottom>Internal</Typography>
            <Grid container>
                {
                    Object.keys(INTERNAL_CHECKBOX_FILTER_LABELS).map((value) => {
                        return (
                            <Grid item size={3} key={value}>
                                <CheckboxFilter
                                    value={INTERNAL_CHECKBOX_FILTER_LABELS[value]}
                                    comparableType={props.comparableType}
                                    attrName={value}
                                />
                            </Grid>
                        );
                    })
                }

            </Grid>
            <Divider orientation="horizontal" sx={{mt: 3, mb: 3}}/>
            <Grid container spacing={3}>
                {
                    Object.keys(INTERNAL_RANGE_FILTER_LABELS).map((value) => {
                        return (
                            <Grid item size={4} key={value}>
                                <RangeAutocomplete
                                    comparableType={props.comparableType}
                                    attrName={value}
                                    label={INTERNAL_RANGE_FILTER_LABELS[value]}
                                    subLabel="Select an option or manually enter a value"
                                    minOptions={ONE_TO_SIX_OPTIONS_MIN}
                                    maxOptions={ONE_TO_SIX_OPTIONS_MAX}
                                    isDropdown={false}
                                    validateInput={validateInput}
                                />
                            </Grid>
                        );
                    })
                }
                <Grid item size={4}>
                    <TextFieldFilter
                        title="Heritage/Other Classification"
                        label="Heritage/Other Classification"
                        comparableType={props.comparableType}
                        attrName="heritageOtherClassification"
                        maxLength={60}
                        width="100%"
                    />
                </Grid>
            </Grid>
            <Divider orientation="horizontal" sx={{mt: 3, mb: 3}}/>
        </Box>
    );
}

export default React.memo(InternalFilter);